import { AuthMode } from '../types/AuthTypes';

/**
 * AuthDetection
 * 
 * Utility to detect whether to use B2C or Entra authentication
 */
export class AuthDetection {
  /**
   * Determine authentication mode based on context
   */
  static getAuthMode(): AuthMode {
    // Check URL first (impersonation landing)
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('organizationToken')) {
      return 'entra';
    }

    // Check session (already impersonating)
    if (sessionStorage.getItem('organizationToken')) {
      return 'entra';
    }

    // Check if we're in an iframe (likely impersonation)
    if (this.isImpersonationContext()) {
      return 'entra';
    }

    // Default to B2C
    return 'b2c';
  }

  /**
   * Check if running in iframe context
   */
  static isImpersonationContext(): boolean {
    try {
      return window.self !== window.top;
    } catch {
      // Cross-origin iframe access denied
      return true;
    }
  }

  /**
   * Check if on impersonation route
   */
  static isImpersonationRoute(): boolean {
    return window.location.pathname.startsWith('/impersonate');
  }
}
